import React from 'react';
import styled from '@emotion/styled';

import { rem } from '../utilities/style';
import { colors } from '../theme/colors';
import { body } from '../styles/type';
import { shadow } from '../styles/box';

import { ReactComponent as IconInfo } from '../images/icons/info.svg';

const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${rem(32)};
  height: ${rem(32)};
  background: none;
  border: none;
`;

const Icon = styled.span`
  position: relative;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: ${rem(16)};
  height: ${rem(16)};
  border-radius: 50%;
  background-color: ${colors.blue['800']};
  cursor: pointer;
`;

const Text = styled.p`
  ${shadow}
  ${body.small}
  position: absolute;
  z-index: 1;
  top: 100%;
  margin-top: ${rem(12)};
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: ${rem(240)};
  padding: ${rem(8)} ${rem(12)};
  border-radius: ${rem(10)};
  background-color: ${colors.white};
  color: ${colors.gray['600']};
  opacity: 0;
  visibility: hidden;
  transition: opacity .2s ease, visibility .2s ease;

  ${IconButton}:active &,
  ${IconButton}:focus &,
  ${IconButton}:hover & {
    opacity: 1;
    visibility: visible;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    width: ${rem(14)};
    height: ${rem(14)};
    border-radius: ${rem(2)};
    transform: translate(-50%, -50%) rotate(45deg);
    background-color: inherit;
  }
`;

const Tooltip = ({ className, children }) => (
  <IconButton
    className={className}
    type="text"
    aria-label="tooltip"

  >
    <Icon>
      <IconInfo aria-hidden="true" />
      <Text>
        {children}
      </Text>
    </Icon>
  </IconButton>
);

export default styled(Tooltip)();
